var _defs, _path, _path2, _path3, _path4, _path5, _path6, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgViapass(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: url(#Naamloos_verloop_2);\n      }\n\n      .cls-2 {\n        fill: url(#Naamloos_verloop_3);\n      }\n\n      .cls-3 {\n        fill: #323232;\n      }\n\n      .cls-4 {\n        fill: #bebebe;\n      }\n    "), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Naamloos_verloop_3",
    "data-name": "Naamloos verloop 3",
    x1: 162.27,
    y1: 268,
    x2: 162.27,
    y2: 212.45,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#4d4d4d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#4d4d4d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#323232"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Naamloos_verloop_2",
    "data-name": "Naamloos verloop 2",
    x1: 131.51,
    y1: 354.09,
    x2: 153.81,
    y2: 270.85,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#f8f8f8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#4d4d4d",
    stopOpacity: 0.95
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4d4d4d"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m215.3,258.82c-.68,2.95-3.16,5.48-6.13,6.43-5.58,1.79-11.81,2.74-17.72,2.74-6.43,0-11.13-1.58-14.01-4.64-2.88-3.06-3.78-7.38-2.58-12.55,1.19-5.17,4.01-9.18,8.28-12.13,4.29-3.06,9.72-4.64,16.15-4.64h10.86l.85-3.69c1.02-4.43-1.44-7.91-6.93-7.91-4.95,0-7.84.63-12.05,2.85-.96.53-2.22.95-3.17.95-2.85,0-4.68-2.11-4.07-4.75.44-1.9,1.72-3.79,3.76-4.85,6.45-3.27,11.63-4.22,19.22-4.22,11.81,0,16.27,8.54,14.11,17.93l-6.57,28.47Zm-7.45-14.76h-10.86c-9.17,0-10.85,4.96-11.26,6.75-.44,1.9-1.13,7.17,8.05,7.17,3.59,0,7.61-.53,11.18-1.37l2.9-12.55Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m232.65,219.8c.49-2.13,2.29-3.94,4.49-4.68,5.53-1.81,11.16-2.66,16.69-2.66,11.61,0,17.56,7.88,14.88,19.49l-3.81,16.5c-2.68,11.61-12.27,19.49-23.88,19.49-4.36,0-8.25-1.17-11.51-3.19l-5.14,22.26c-.47,2.02-2.43,3.62-4.46,3.62s-3.25-1.6-2.79-3.62l15.51-67.19Zm28.94,11.61c1.77-7.67-1.75-12.25-9.31-12.25-4.26,0-8.45.64-12.66,1.81l-8.31,35.99c2.59,3.09,6.68,4.26,11.26,4.26,7.56,0,13.2-4.58,14.97-12.24l4.06-17.57Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m306.67,260.59c-.49,2.13-2.32,4.04-4.49,4.68-5.5,1.7-11.05,2.66-16.59,2.66-6.5,0-11.13-1.6-13.74-4.58-2.45-2.77-3.11-6.81-1.96-11.82,1.16-5.01,3.66-8.94,7.42-11.82,3.99-2.98,9.29-4.26,15.78-4.26h12.14l1.55-6.71c1.45-6.28-2.37-9.58-9.07-9.58-4.26,0-8.49,1.28-13.08,3.62-.61.32-1.19.53-1.83.53-1.92,0-3.33-1.28-2.83-3.41.29-1.28,1.2-2.45,2.55-3.2,5.72-3.09,11.52-4.26,16.74-4.26,10.01,0,17.3,5.32,14.79,16.19l-7.38,31.95Zm-2.99-18.42h-12.14c-10.86,0-13.42,5.11-14.41,9.37-.98,4.26-.85,9.69,10.01,9.69,4.15,0,8.45-.64,12.56-1.81l3.98-17.25Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m329.06,240.46c-4.51-2.13-7.89-5.96-6.14-13.52,2.04-8.84,11.12-14.48,20.59-14.48,5.22,0,9.13,1.06,12.38,2.66,1.24.64,1.79,1.92,1.45,3.41-.44,1.92-2.36,3.3-4.38,3.3-.42,0-.83-.11-1.31-.32-2.85-1.49-6.49-2.34-10.53-2.34s-9.62,2.02-10.88,7.46c-.98,4.26,1.51,6.39,3.63,7.35l9.08,4.05c5.8,2.56,8.88,7.67,7.38,14.16-2.04,8.84-10.88,15.76-20.67,15.76-5.54,0-9.74-1.17-13.34-3.09-1.24-.64-1.71-1.81-1.37-3.3.44-1.92,2.28-3.41,4.41-3.41.53,0,.91.21,1.39.43,3.06,1.49,6.52,2.66,10.78,2.66,5,0,10.17-2.98,11.3-7.88,1.03-4.47-.66-6.81-4.69-8.73l-9.05-4.15Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m367.9,240.46c-4.51-2.13-7.89-5.96-6.14-13.52,2.04-8.84,11.12-14.48,20.59-14.48,5.22,0,9.13,1.06,12.38,2.66,1.23.64,1.79,1.92,1.45,3.41-.44,1.92-2.36,3.3-4.38,3.3-.42,0-.83-.11-1.31-.32-2.85-1.49-6.49-2.34-10.53-2.34s-9.62,2.02-10.88,7.46c-.98,4.26,1.51,6.39,3.63,7.35l9.07,4.05c5.8,2.56,8.88,7.67,7.38,14.16-2.04,8.84-10.88,15.76-20.68,15.76-5.54,0-9.74-1.17-13.34-3.09-1.24-.64-1.71-1.81-1.37-3.3.44-1.92,2.28-3.41,4.41-3.41.53,0,.91.21,1.4.43,3.06,1.49,6.52,2.66,10.78,2.66,5.01,0,10.17-2.98,11.3-7.88,1.03-4.47-.66-6.81-4.69-8.73l-9.05-4.15Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m158.1,193.53c-1.1-1.13-2.7-1.6-4.36-1.27-2.26.45-4.39,2.44-5.17,4.83l-16.26,49.7-16.01-52.14c-.59-1.91-2.31-3.15-4.38-3.15-.34,0-.67.03-1.01.1-2.96.59-5.54,3.7-5.63,6.79-.02.64.06,1.19.27,1.87l20.44,64.19c.71,2.18,2.53,3.53,4.75,3.53.38,0,.77-.04,1.17-.12,2.63-.52,4.97-2.71,5.84-5.44l21.36-63.3c.22-.58.36-1.27.38-1.88.04-1.43-.45-2.75-1.38-3.71Z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "179.4 206.87 182.77 192.26 171.83 192.26 166.92 206.87 179.4 206.87"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "165.29 268 178.11 212.45 165.04 212.45 146.43 268 165.29 268"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "144.53 273.58 118.66 350.64 146.19 350.64 164 273.58 144.53 273.58"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgViapass);
export default __webpack_public_path__ + "static/media/viapass.2860994095aad2959be17bde33fb8a05.svg";
export { ForwardRef as ReactComponent };